import '../../assets/css/navVerical.css'
import '../../assets/css/responsive_navVertical.css'
import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Tooltip from '@mui/material/Tooltip';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ContactlessIcon from '@mui/icons-material/Contactless';
import LanguageIcon from '@mui/icons-material/Language';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StoreIcon from '@mui/icons-material/Store';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import SendIcon from '@mui/icons-material/Send';
import PriceCheckIcon from '@mui/icons-material/PriceCheck';
import EventIcon from '@mui/icons-material/Event';
import InventoryIcon from "@mui/icons-material/Inventory";

import logoKertys from '../img/logoKertys.png';
import { get_company_logo } from '../../services/for_allServices';
import NavBar from '../service_navBar/navBar';
import { useAuth } from '../../contexts/AuthContext';




function Responsive_navVertical({role, habilitations, company_nav_logo, logout, nav_color, Component, menu_color }) {

  function show_sideBar(menu_sm) {
    var sidebar = menu_sm.nextSibling;
    let service_menu_holder = document.getElementById("service_menu_holder");
    if (sidebar && sidebar.className.includes("responsive_service_content")) {
      menu_sm.classList.toggle('open');
      sidebar.classList.toggle('show');
    }
  }

  function close_sidebar() {
    let menu_sm = document.getElementById("service_menu_holder");
    let sidebar = menu_sm.nextSibling;
    if (sidebar && sidebar.className.includes("responsive_service_content")) {
      menu_sm.classList.remove('open');
      sidebar.classList.remove('show');
    }
  }

  return (
    <>
      <div className="responsive_navVertical">
        <div id="service_menu_holder" onClick={(event) => show_sideBar(event.target)} style={{ background: menu_color }}>
          <div onClick={(event) => show_sideBar(event.target.parentNode)} style={{ background: nav_color }}></div>
          <div onClick={(event) => show_sideBar(event.target.parentNode)} style={{ background: nav_color }}></div>
          <div onClick={(event) => show_sideBar(event.target.parentNode)} style={{ background: nav_color }}></div>
        </div>
        <div className="responsive_service_content" style={{ background: nav_color }}>
          <Link className="company_nav_logo_container" onTouchEnd={close_sidebar} to={role + ""}>
            {
              company_nav_logo !== null
                ? <><img src={company_nav_logo !== "" ? `data:image/*;base64,${company_nav_logo}` : logoKertys} /></>
                : <></>
            }
          </Link>

          <div className='menu_items'>
            <div>
              <Link className={window.location.pathname === role + "/tableauDeBord" ? "menu_item menu_item_selected" : "menu_item"} onTouchEnd={close_sidebar} to={role + "/tableauDeBord"}>
                <div><DashboardIcon /><span className="title_menu_item">Tableau de bord </span> </div>
              </Link>
              <Link className={window.location.pathname === role + "/Fiche_Identite" ? "menu_item menu_item_selected" : "menu_item"} onTouchEnd={close_sidebar} to={role + "/Fiche_Identite"}>
                <div><AccountCircleIcon /><span className="title_menu_item">Fiche d'identité</span> </div>
              </Link>
              {
                habilitations.hasOwnProperty("Consultation des factures") && habilitations["Consultation des factures"] == true
                  ? <Link className={window.location.pathname === role + "/facture" ? "menu_item menu_item_selected" : "menu_item"} onTouchEnd={close_sidebar} to={role + "/facture"}>
                    <div><ContactlessIcon /><span className="title_menu_item">Factures / Paiements</span> </div>
                  </Link> : <></>
              }
              {
                habilitations.hasOwnProperty("Création des DAS") && habilitations["Création des DAS"] == true
                  ? <Link className={window.location.pathname === role + "/demande_achat" ? "menu_item menu_item_selected" : "menu_item"} onTouchEnd={close_sidebar} to={role + "/demande_achat"}>
                    <div><StoreIcon /><span className="title_menu_item">Ajouter une demande d'achat </span> </div>
                  </Link> : <></>
              }
              {
                habilitations.hasOwnProperty("Consultation des DAS") && habilitations["Consultation des DAS"] == true
                  ? <Link className={window.location.pathname === role + "/demandes" ? "menu_item menu_item_selected" : "menu_item"} onTouchEnd={close_sidebar} to={role + "/demandes"}>
                    <div><RequestPageIcon /><span className="title_menu_item">Demandes d'achats </span> </div>
                  </Link> : <></>
              }
              {
                habilitations.hasOwnProperty("Gestion des projets") && habilitations["Gestion des projets"] == true
                  ? <Link to={role + "/projets"} onTouchEnd={close_sidebar} className={window.location.pathname === role + "/projets" ? "menu_item menu_item_selected" : "menu_item"}>
                    <div>
                      <EventIcon />{" "}
                      <span className="title_menu_item">Projets</span>{" "}
                    </div>
                  </Link> : <></>
              }
              {
                habilitations.hasOwnProperty("Gestion du stock") && habilitations["Gestion du stock"] == true
                  ? <Link to={role + "/stock"} onTouchEnd={close_sidebar} className={window.location.pathname === role + "/stock" ? "menu_item menu_item_selected" : "menu_item"}>
                    <div>
                      <InventoryIcon />{" "}
                      <span className="title_menu_item">Stock</span>{" "}
                    </div>
                  </Link> : <></>
              }
              {
                habilitations.hasOwnProperty("Validation des DAS") && habilitations["Validation des DAS"] == true
                  ? <Link className={window.location.pathname === role + "/demandes_validation" ? "menu_item menu_item_selected" : "menu_item"} onTouchEnd={close_sidebar} to={role + "/demandes_validation"}>
                    <div><PriceCheckIcon /><span className="title_menu_item">Demandes d'achat à approuver </span> </div>
                  </Link> : <></>
              }
              <Link to={role + "/envoyer_email"} onTouchEnd={close_sidebar} className={window.location.pathname === role + "/envoyer_email" ? "menu_item menu_item_selected" : "menu_item"}>
                <div ><SendIcon /> <span className="title_menu_item">Envoyer un email</span> </div>
              </Link>
            </div>

            <div className="menu-connection">
              <div className="menu_item" onClick={logout}>
                <div><ExitToAppIcon /> <span className="title_menu_item">Logout</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="responsive_service_body">
        {
          Component
            ? <>
              <Component />
            </>
            : <></>
        }
      </div>
    </>
  )
}



function NavVertical_services({ Component }) {
  const { logout } = useAuth();

  let history = useHistory();
  let user = JSON.parse(localStorage.getItem('user-info'))

  const [responsive_menu, setResponsive_menu] = useState(null);
  const [habilitations, setHabilitations] = useState(null);


  const [role, setRole] = useState("");
  const [company_nav_logo, setcompany_nav_logo] = useState(null);
  const [company_logo, setcompany_logo] = useState(null);

  const [nav_color, setNav_color] = useState('');
  const [menu_color, setMenu_color] = useState('');

  useEffect(() => {
    async function check_width() {
      if (window.innerWidth > 1010) {
        setResponsive_menu(false);
      } else {
        setResponsive_menu(true);
      }
    }

    async function load_data() {
      await setRole(user.role === 2 ? "/serviceMetier" : user.role === 3 ? "/serviceFinance" : "");
      await setHabilitations(user.habilitations);
      await check_width();
      await setNav_color(user.company_color.split(',')[0]);
      await setMenu_color(user.company_color.split(',')[1]);
      await get_company_logo().then((response) => {
        setcompany_nav_logo(response.data.company_nav_logo);
        setcompany_logo(response.data.company_logo);
      }).catch((error) => {
        //console.log(error.response);
      })
    }
    load_data();
  }, []);

  const load_component = React.useMemo(() => {
    return (
      <>
        {
          Component
            ? <>
              <Component />
            </>
            : <></>
        }
      </>
    )
  }, [Component])

  return (
    <>
      {
        responsive_menu != null
          ? <><NavBar menu_color={menu_color} company_logo={company_logo} />
            <div className="nav_menu_container">
              {
                responsive_menu !== true
                  ? <><div className="service_content show" style={{ background: nav_color }}>

                    <Link className="company_nav_logo_container" to={role + ""}>
                      {
                        company_nav_logo !== null
                          ? <><img src={company_nav_logo !== "" ? `data:image/*;base64,${company_nav_logo}` : logoKertys} /></>
                          : <></>
                      }
                    </Link>

                    <div className='menu_items'>
                      <div>
                        <Tooltip title="Tableau de bord" placement="right" arrow>
                          <Link className={window.location.pathname === role + "/tableauDeBord" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/tableauDeBord"}>
                            <div><DashboardIcon /></div>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Fiche d'identité" placement="right" arrow>
                          <Link className={window.location.pathname === role + "/Fiche_Identite" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/Fiche_Identite"}>
                            <div><AccountCircleIcon /></div>
                          </Link>
                        </Tooltip>
                        {
                          habilitations.hasOwnProperty("Consultation des factures") && habilitations["Consultation des factures"] == true
                            ? <Tooltip title="Factures / Paiements" placement="right" arrow>
                              <Link className={window.location.pathname === role + "/facture" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/facture"}>
                                <div><ContactlessIcon /></div>
                              </Link>
                            </Tooltip> : <></>
                        }
                        {
                          habilitations.hasOwnProperty("Création des DAS") && habilitations["Création des DAS"] == true
                            ? <Tooltip title="Ajouter une demande d'achat" placement="right" arrow>
                              <Link className={window.location.pathname === role + "/demande_achat" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/demande_achat"}>
                                <div><StoreIcon /></div>
                              </Link>
                            </Tooltip>
                            : <></>
                        }
                        {
                          habilitations.hasOwnProperty("Consultation des DAS") && habilitations["Consultation des DAS"] == true
                            ? <Tooltip title="Demandes d'achats" placement="right" arrow>
                              <Link className={window.location.pathname === role + "/demandes" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/demandes"}>
                                <div><RequestPageIcon /></div>
                              </Link>
                            </Tooltip>
                            : <></>
                        }
                        {
                          habilitations.hasOwnProperty("Gestion des projets") && habilitations["Gestion des projets"] == true
                            ? <Tooltip title="Projets" placement="right" arrow>
                              <Link
                                className={
                                  window.location.pathname === role + "/projets"
                                    ? "menu_item menu_item_selected"
                                    : "menu_item"
                                }
                                to={role + "/projets"}
                              >
                                <div>
                                  <EventIcon />
                                </div>
                              </Link>
                            </Tooltip>
                            : <></>
                        }
                        {
                          habilitations.hasOwnProperty("Gestion du stock") && habilitations["Gestion du stock"] == true
                            ? <Tooltip title="Stock" placement="right" arrow>
                              <Link
                                className={
                                  window.location.pathname === role + "/stock"
                                    ? "menu_item menu_item_selected"
                                    : "menu_item"
                                }
                                to={role + "/stock"}
                              >
                                <div>
                                  <InventoryIcon />
                                </div>
                              </Link>
                            </Tooltip>
                            : <></>
                        }
                        {
                          habilitations.hasOwnProperty("Validation des DAS") && habilitations["Validation des DAS"] == true
                            ? <Tooltip title="Demandes d'achat à approuver" placement="right" arrow>
                              <Link className={window.location.pathname === role + "/demandes_validation" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/demandes_validation"}>
                                <div><PriceCheckIcon /></div>
                              </Link>
                            </Tooltip>
                            : <></>
                        }
                        <Tooltip title="Envoyer un email" placement="right" arrow>
                          <Link className={window.location.pathname === role + "/envoyer_email" ? "menu_item menu_item_selected" : "menu_item"} to={role + "/envoyer_email"} >
                            <div><SendIcon /></div>
                          </Link>
                        </Tooltip>

                      </div>

                      <div className="menu-connection">
                        <Tooltip title="Logout" placement="right" arrow>
                          <div className="menu_item" onClick={logout}>
                            <div><ExitToAppIcon /></div>
                          </div>
                        </Tooltip>
                      </div>

                    </div>
                  </div>

                    <div className="service_body">
                      {load_component}
                    </div>
                  </>
                  : <Responsive_navVertical role={role} habilitations={habilitations} company_nav_logo={company_nav_logo} logout={logout} nav_color={nav_color} Component={Component} menu_color={menu_color} />
              }
            </div>
          </>
          : <></>
      }
    </>

  );
}

export default NavVertical_services;
